export default {
  'menu.commerce': 'Commerce',
  'pages.commerce.action.column': 'Action',
  'pages.commerce.action.detail': 'Detail',
  'pages.commerce.action.disable': 'Disable',
  'pages.commerce.action.edit': 'Edit',
  'pages.commerce.action.price': 'Price',
  'pages.commerce.action.query': 'Query',
  'pages.commerce.action.refresh': 'Refresh',
  'pages.commerce.empty.data': 'No data',
  'pages.commerce.message.saved': 'Done',
  'pages.commerce.order.amount': 'Amount',
  'pages.commerce.order.createdAt': 'Created at',
  'pages.commerce.order.currency': 'Currency',
  'pages.commerce.order.dateRange': 'Date range',
  'pages.commerce.order.detail.basic': 'Basic info',
  'pages.commerce.order.detail.skuSnapshot': 'SKU snapshot',
  'pages.commerce.order.detail.statusTime': 'Status and time',
  'pages.commerce.order.drawerTitle': 'Order detail',
  'pages.commerce.order.field.amount': 'Amount',
  'pages.commerce.order.field.createdAt': 'Created at',
  'pages.commerce.order.field.currency': 'Currency',
  'pages.commerce.order.field.expiresAt': 'Expires at',
  'pages.commerce.order.field.fulfilledAt': 'Fulfilled at',
  'pages.commerce.order.field.memo': 'Memo',
  'pages.commerce.order.field.orderId': 'Order ID',
  'pages.commerce.order.field.paidAt': 'Paid at',
  'pages.commerce.order.field.payMethod': 'Pay method',
  'pages.commerce.order.field.sendOrderId': 'Send order ID',
  'pages.commerce.order.field.skuId': 'SKU ID',
  'pages.commerce.order.field.skuSnapshotType': 'SKU type',
  'pages.commerce.order.field.status': 'Status',
  'pages.commerce.order.field.updatedAt': 'Updated at',
  'pages.commerce.order.field.userId': 'User ID',
  'pages.commerce.order.field.walletRedPacketId': 'Wallet red packet ID',
  'pages.commerce.order.fulfilledAt': 'Fulfilled at',
  'pages.commerce.order.level.effectiveFrom': 'Effective from',
  'pages.commerce.order.level.effectiveUntil': 'Effective until',
  'pages.commerce.order.level.tier': 'Tier',
  'pages.commerce.order.level.tierName': 'Tier name',
  'pages.commerce.order.level.title': 'Level',
  'pages.commerce.order.orderId': 'Order ID',
  'pages.commerce.order.page': 'Page',
  'pages.commerce.order.pageSize': 'Page size',
  'pages.commerce.order.paidAt': 'Paid at',
  'pages.commerce.order.payMethod': 'Pay method',
  'pages.commerce.order.skuSnapshot': 'SKU snapshot',
  'pages.commerce.order.skuId': 'SKU ID',
  'pages.commerce.order.skuType': 'SKU type',
  'pages.commerce.order.status': 'Status',
  'pages.commerce.order.status.created': 'Created',
  'pages.commerce.order.status.pending': 'Pending',
  'pages.commerce.order.status.paying': 'Paying',
  'pages.commerce.order.status.paid': 'Paid',
  'pages.commerce.order.status.done': 'Done',
  'pages.commerce.order.status.pay_failed': 'Pay failed',
  'pages.commerce.order.status.closed': 'Closed',
  'pages.commerce.order.status.expired': 'Expired',
  'pages.commerce.order.status.refunding': 'Refunding',
  'pages.commerce.order.status.refunded': 'Refunded',
  'pages.commerce.order.status.refund_failed': 'Refund failed',
  'pages.commerce.order.status.active': 'Active',
  'pages.commerce.order.status.claimed': 'Claimed',
  'pages.commerce.order.status.failed': 'Failed',
  'pages.commerce.order.status.withdrawing': 'Withdrawing',
  'pages.commerce.order.txnType': 'Transaction type',
  'pages.commerce.order.total': 'Total',
  'pages.commerce.order.detail.queryInfo': 'Query info',
  'pages.commerce.order.summary.firstOrderAt': 'First order at',
  'pages.commerce.order.summary.orderCount': 'Order count',
  'pages.commerce.order.summary.title': 'Summary',
  'pages.commerce.order.summary.totalRefunded': 'Total refunded',
  'pages.commerce.order.summary.totalSpent': 'Total spent',
  'pages.commerce.order.uid': 'UID',
  'pages.commerce.order.userId': 'User ID',
  'pages.commerce.order.userOrderDetail': 'User order detail',
  'pages.commerce.price.active': 'Active',
  'pages.commerce.price.amount': 'Amount',
  'pages.commerce.price.currency': 'Currency',
  'pages.commerce.price.payMethod': 'Pay method',
  'pages.commerce.price.upsert': 'Upsert price',
  'pages.commerce.reconcile.title': 'Level reconcile',
  'pages.commerce.reconcile.trigger': 'Trigger reconcile',
  'pages.commerce.sku.basicInfo': 'Basic info',
  'pages.commerce.sku.code': 'SKU code',
  'pages.commerce.sku.create': 'Create SKU',
  'pages.commerce.sku.disableConfirm': 'Disable this SKU?',
  'pages.commerce.sku.drawerTitle': 'SKU detail',
  'pages.commerce.sku.durationDays': 'Duration days',
  'pages.commerce.sku.edit': 'Edit SKU',
  'pages.commerce.sku.name': 'Name',
  'pages.commerce.sku.priceCount': 'Prices',
  'pages.commerce.sku.prices': 'Prices',
  'pages.commerce.sku.skuId': 'SKU ID',
  'pages.commerce.sku.status': 'Status',
  'pages.commerce.sku.targetLevelId': 'Target level',
  'pages.commerce.sku.type': 'Type',
  'pages.commerce.tab.orders': 'Orders',
  'pages.commerce.tab.reconcile': 'Reconcile',
  'pages.commerce.tab.skus': 'SKU management',
  'pages.commerce.title': 'Commerce',
};
